var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.12,
    height: 47.12,
    viewBox: "0 0 47.12 47.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M23.56.563a23.56,23.56,0,1,0,23.56,23.56A23.556,23.556,0,0,0,23.56.563Zm0,9.12a8.36,8.36,0,1,1-8.36,8.36A8.36,8.36,0,0,1,23.56,9.683Zm0,32.68A18.2,18.2,0,0,1,9.643,35.884,10.592,10.592,0,0,1,19,30.2a2.325,2.325,0,0,1,.675.1,12.578,12.578,0,0,0,3.886.656,12.53,12.53,0,0,0,3.886-.656,2.324,2.324,0,0,1,.675-.1,10.592,10.592,0,0,1,9.358,5.681A18.2,18.2,0,0,1,23.56,42.363Z",
    transform: "translate(0 -0.563)",
    fill: "#1fd3a4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d21f16789b31efc3f750b41ea5bb4f3c.svg";
export { ForwardRef as ReactComponent };